import React from 'react';
import '../styles/temperature_item.scss';

class TemperatureItem extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            editMode: false
        };
    };

    handleOnEditMode() {
        if (this.props.changesItem && this.props.changesItem.inputValue)
            return;
        this.setState({editMode: true});
    };

    applyChanges(o) {
        let item = this.props.changesItem;
        if (!item || isNaN(parseInt(item.inputValue)))
            return;
        this.props.handleApplyItem(o);
        this.setState({editMode: false})
    };

    onFieldChanged(o) {
        let val = o.target.value;
        this.props.handleInputValue(this.props.item.id, val);
    };

    render() {
        let changesItem = this.props.changesItem;
        let temperatureVal = changesItem ? changesItem.inputValue + (this.state.editMode ? "" : "°C") : this.props.item.inputValue;
        let dKey = this.props.item.id;

        let indicator, itemBody, applyBtn;
        if (this.state.editMode) {
            indicator = (<div className="hc-temperature-btn-done">
                            <div style={{backgroundColor: "#EAF6F4"}}>
                                <div className="hc-checkbox-notchecked"></div>
                            </div>
                        </div>);
            itemBody = (<div className="hc-f3 hc-f-l hc-temperature-content120">
                            <input className="hc-f4 hc-temperature-input" type="text" placeholder={HC_LANG.CHL_ADD_TEMP}
                                   value={temperatureVal} onChange={this.onFieldChanged.bind(this)} spellCheck="false"/>
                        </div>);
            applyBtn = (<div className="hc-due-check-active hc-temperature-btn-apply"  data-key={dKey} onClick={this.applyChanges.bind(this)}>
                            <div data-key={dKey}>
                                <i className="fa hc-fa-medium fa-check" data-key={dKey}></i>
                            </div></div>)
        }
        else {
            indicator = (
                <div className={"hc-temperature-btn-done hc-due-check" + (changesItem && changesItem.inputValue != undefined ? "-active" : "")}
                     onClick={this.handleOnEditMode.bind(this)}>
                    <div>
                        <i  className="fa hc-fa-medium fa-check"></i>
                    </div>
                </div>);
            itemBody = (<div className="hc-f3 hc-temperature-content60">
                <div className="hc-temperature-question-container">
                    <div>{this.props.item.item}</div>
                    <div>{temperatureVal}</div>
                </div>
            </div>);
        }


        return (
            <div className="hc-temperature-container" >
                {indicator}
                {itemBody}
                {applyBtn}
            </div>
        )
    }
}

module.exports = TemperatureItem;



// WEBPACK FOOTER //
// ./dues/temperature_item.js